import React from 'react';
import { Link } from 'react-router-dom';

export default function DopplerScan() {
  return (
    <>
      <div className='services-item container' id='dopplerScan'>
        <div className='row'>

          {/* Description */}
          <div className='col-lg-6 col-md-6 col-sm-12 v-align-middle p-0 order-lg-1 order-md-1 order-2'>
            <div className='services-item-content'>
              <h2>Doppler <span>Scan</span></h2>

              <p>
                FamPhy's Doppler Scan service evaluates blood flow through arteries
                and veins using advanced ultrasound technology. It helps diagnose
                circulation problems, blood clots, blocked arteries, varicose veins,
                and other vascular conditions with accurate, non-invasive imaging.
              </p>

              <Link to="/contact" className="btn theam-btn-m">
                Contact Us
              </Link>
            </div>
          </div>

          {/* Image */}
          <div className='col-lg-6 col-md-6 col-sm-12 p-0 order-lg-2 order-md-2 order-1'>
            <img
              className="img-fluid"
              src={`${process.env.PUBLIC_URL}/img/dop.png`}
              alt="Doppler Scan"
            />
          </div>

        </div>
      </div>
    </>
  );
}